module.exports = __webpack_public_path__ + "green.jpg?3dd1e1d693bcbb0368d2e274283043f0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calendar-info/green.jpg
// module id = 488
// module chunks = 1